import { render, staticRenderFns } from "./BidPriceInfo.vue?vue&type=template&id=2844ba2a&scoped=true&"
import script from "./BidPriceInfo.vue?vue&type=script&lang=js&"
export * from "./BidPriceInfo.vue?vue&type=script&lang=js&"
import style0 from "./BidPriceInfo.vue?vue&type=style&index=0&id=2844ba2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844ba2a",
  null
  
)

export default component.exports